<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Copyright</h1>
</div>
</div>
<h1 class="head">
	Copyright</h1>
<div class="halftitle">
<div class="copy_block">
<p class="center">
			Diversion Books</p>
<p class="center">
			A Division of Diversion Publishing Corp.</p>
<p class="center">
			443 Park Avenue South, Suite 1004</p>
<p class="center">
			New York, NY 10016</p>
<p class="center">
<a href="http://www.diversionbooks.com" target="_blank">www.DiversionBooks.com</a></p>
</div>
<div class="copy_block">
<p class="center">
			Copyright © 1993 by Anna Eberhardt</p>
</div>
<div class="copy_block">
<p class="center">
			All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.</p>
</div>
<div class="copy_block">
<p class="center">
			For more information, email <a href="http://info@diversionbooks.com" target="_blank">info@diversionbooks.com</a>.</p>
<p class="center">
			First Diversion Books edition May 2013.</p>
<p class="center">
			ISBN: 9781626810181</p>
</div>
</div>
<p>
</p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<p>
</p>
<p style="text-align: center;">
<em><strong>Also by Tiffany White</strong></em></p>
<p style="text-align: center;">
<span href="#/chap153849" title="Link target outside of Sample">A Dark &amp; Stormy Knight</span></p>
<p style="text-align: center;">
<span href="#/chap153849" title="Link target outside of Sample">A Kiss in the Dark</span></p>
<p style="text-align: center;">
<span href="#/chap153849" title="Link target outside of Sample">Bad Attitude</span></p>
<p style="text-align: center;">
<span href="#/chap153849" title="Link target outside of Sample">Cheap Thrills</span></p>
<p style="text-align: center;">
<span href="#/chap153849" title="Link target outside of Sample">Forbidden Fantasy</span></p>
<p style="text-align: center;">
<span href="#/chap153849" title="Link target outside of Sample">Love, Me</span></p>
<p style="text-align: center;">
<span href="#/chap153849" title="Link target outside of Sample">Naughty by Night</span></p>
<p style="text-align: center;">
<span href="#/chap153849" title="Link target outside of Sample"><span style="text-indent: 1.5em; font-size: 1em; line-height: 1.4;">Open Invitation</span></span></p>
<p style="text-align: center;">
<span href="#/chap153849" title="Link target outside of Sample">Restless Nights</span></p>
<p style="text-align: center;">
<span href="#/chap153849" title="Link target outside of Sample">The 6′1″ Grinch</span></p>
<p>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap133645.vue?7ff4acf4